import Vue from 'vue'
import VueQRCodeComponent from 'vue-qrcode-component'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'element-mobile/dist/element-mobile.css'
import http from './utils/http'
import util from './utils/util'
import mdui from 'mdui'

import Vant from 'vant'
import 'vant/lib/index.css'

const DEFAULT_MERCHANT_IDENTITY = '66378f481c9c43b7a0044c7a5221b530'

Vue.prototype.util = util
Vue.prototype.mdui = mdui
Vue.use(http)
Vue.config.productionTip = false
Vue.component('qr-code', VueQRCodeComponent)
Vue.use(Vant)

new Vue({
  router,
  store,
  render: h => h(App),
  beforeMount () {
    const appToken = window.ucityApp && typeof window.ucityApp.getToken === 'function'
      ? window.ucityApp.getToken()
      : ''
    const token = appToken || this.$route.query.token || util.getUserToken()
    const merchantIdentity = this.$route.query.merchantIdentity || DEFAULT_MERCHANT_IDENTITY

    this.$store.commit('setToken', token)
    util.setMerchantIdentity(merchantIdentity)
    // window.authcode = this.$route.query.code
    // if (window.authcode) {
    //  store.commit('setToken', '')
    //  util.setUserToken('')
    //  this.$axios
    //    .post('/tp/application/user/h5/gettoken', { 'Code': window.authcode }) // this.guid
    //    .then(data => {
    //      if (data) {
    //        let q = Object.assign({}, this.$route.query)
    //        delete q['code']
    //        if (data.Code === 200) {
    //          this.$router.replace({ query: q })
    //          this.$store.commit('setToken', data.Data.Token)
    //        } else if (data.Code === -404) {
    //        } else {
    //          this.mdui.snackbar({
    //            message: data.Message,
    //            position: 'bottom'
    //          })
    //        }
    //      }
    //    })
    //    .catch(e => console.log(e))
    // }
    // if (this.$route.query.guidActivity) {
    //   window.guidActivity = this.$route.query.guidActivity
    // } else {
    //   mdui.dialog({
    //     title: '提示',
    //     content: '未知活动',
    //     history: false,
    //     buttons: [
    //       {
    //         text: '确认',
    //         onClick: inst => {
    //         }
    //       }
    //     ]
    //   })
    // }
    // if (this.$route.query.merchantIdentity) {
    //   util.setLocalStorage('MerchantIdentity', this.$route.query.merchantIdentity)
    // } else {
    //   mdui.dialog({
    //     title: '提示',
    //     content: '未知商户',
    //     history: false,
    //     buttons: [
    //       {
    //         text: '确认',
    //         onClick: inst => {
    //         }
    //       }
    //     ]
    //   })
    // }
  },
  mounted () {
    // this.$axios
    //   .post('/itps/api/coupon/activity/detail', { 'GuidActivity': window.guidActivity }) // this.guid
    //   .then(data => {
    //     if (data) {
    //       if (data.Code === 200) {
    //         if (this.$route.path === '/exchange' && data.Data.RewardType === 2 && this.$store.state.Token) {
    //           this.$router.replace({ path: '/cardslist', query: this.$route.query })
    //         }
    //         store.commit('setActivityDetail', data.Data)
    //       } else if (data.Code === -404) {
    //       } else {
    //         this.mdui.snackbar({
    //           message: data.Message,
    //           position: 'bottom'
    //         })
    //       }
    //     }
    //   })
    //   .catch(e => console.log(e))
  }
}).$mount('#app')
